import { Divider } from '@material-ui/core';
import Breadcrumbs from 'components/Common/Breadcrumb';
import TableError from 'components/TableError';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import { buildURL, checkIfValueExist, printDate, printSerialNumbers, urlSlugify } from 'utils/helper';
import { SMKLinks } from 'utils/links';
import Loader from '../../components/Loader';
import Paginate from '../../components/Paginate';
import useRequest from '../../hooks/useRequest';
import { useRouter } from '../../hooks/useRouter';
import { ACTIVE_AND_DELETED_ARRAY } from '../../utils/constants';
import confirm from 'reactstrap-confirm';

const SchoolClinicListing = (props) => {
  const router = useRouter();
  const history = useHistory();
  toast.configure();

  const { query } = router;

  const [schoolClinicsList, setSchoolClinicsList] = useState([]);
  // const [schoolClinicsPagination, setSchoolClinicsPagination] = useState({});

  const defaultFilters = {
    active: { value: null, label: 'All' },
    deleted: { value: null, label: 'All' },
    name: '',
  };

  const [filters, setFilters] = useState(defaultFilters);

  const [getSchoolClinicsListRequest, { loading: getSchoolClinicsListLoading }] = useRequest({
    url: '/school-clinic/admin/search',
    method: 'POST',
    onSuccess: (data) => {
      setSchoolClinicsList(data);
    },
  });

  const [updateSchoolClinicRequest, { loading: updateSchoolClinicLoading }] = useRequest({
    onSuccess: (data) => {
      handleChangePage(1);
      toast.success('Success! School Clinic has been updated.');
    },
  });

  const setPageInUrl = (page) => {
    history.push({
      pathname: router.pathname,
      search: `?${new URLSearchParams({ page }).toString()}`,
    });
  };

  const handleChangePage = (page) => {
    setPageInUrl(page);

    getSchoolClinicsListRequest({
      body: {
        page,
        size: 50,
        sortOrder: 1,
        active: checkIfValueExist(filters.active?.value),
        deleted: checkIfValueExist(filters.deleted?.value),
        name: checkIfValueExist(filters.name) ? urlSlugify(filters.name?.trim()) : '',
      },
    });
  };

  const applyFilters = () => {
    handleChangePage(1);
  };

  const clearFilters = () => {
    setPageInUrl(1);

    setFilters({ ...defaultFilters });
    getSchoolClinicsListRequest({
      body: {
        page: 1,
        size: 50,
        sortOrder: 1,
        active: checkIfValueExist(defaultFilters.active?.value),
        deleted: checkIfValueExist(defaultFilters.deleted?.value),
        name: checkIfValueExist(defaultFilters.name),
      },
    });
  };

  useEffect(() => {
    handleChangePage(parseInt(router?.query?.page, 10) || 1);
  }, []);

  const handleUpdateSchoolClinic = async (data) => {
    const result = await confirm({
      title: `${data?.active ? 'InActive' : 'Active'} School Clinic`,
      message: `Are you sure, you want to ${data?.active ? 'InActive' : 'Active'} this school clinic?`,
      confirmText: 'Confirm',
      confirmColor: 'primary',
      cancelColor: 'link text-danger',
    });
    if (result) {
      updateSchoolClinicRequest({
        method: 'PUT',
        url: `/school-clinic/admin/${data?.id}/${data?.active ? 'disable' : 'enable'}`,
      });
    }
  };

  return (
    <>
      <div className="page-content">
        <Loader isActive={getSchoolClinicsListLoading || updateSchoolClinicLoading} />
        <Container fluid>
          <Breadcrumbs title="School Clinics" breadcrumbItem={'School Clinics List'} />

          {/* <Card>
            <CardBody>
              <div className="mt-4">
                <div className="row">
                  <div className="col-lg-2 mb-4">
                    <label className="form-label">Active</label>
                    <Select
                      options={ACTIVE_AND_DELETED_ARRAY}
                      value={filters.active}
                      onChange={(value) => {
                        setFilters({ ...filters, active: value });
                      }}
                    />
                  </div>
                  <div className="col-lg-2 mb-4">
                    <label className="form-label">Deleted</label>
                    <Select
                      options={ACTIVE_AND_DELETED_ARRAY}
                      value={filters.deleted}
                      onChange={(value) => setFilters({ ...filters, deleted: value })}
                    />
                  </div>

                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Name</label>
                    <input
                      className="form-control"
                      placeholder="Enter name..."
                      value={filters.name}
                      onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <a className="btn btn-primary me-4" onClick={applyFilters}>
                  Apply Filters
                </a>
                <a className="" onClick={clearFilters}>
                  Clear
                </a>
              </div>
            </CardBody>
          </Card> */}

          <Row className="mb-2 align-items-center">
            <Col sm="4">
              <div className="search-box me-2 mb-2 d-inline-block">
                <div className="position-relative font-bold">{schoolClinicsList?.length} School Clinics Found</div>
              </div>
            </Col>
            <Col sm="8">
              <div className="text-sm-end">
                <Link
                  replace
                  className="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2"
                  to={SMKLinks.SCHOOL_CLINIC_ADD}>
                  <i className="mdi mdi-plus me-1" />
                  Add School Clinic
                </Link>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <div className="">
                <div className="table-responsive" style={{ minHeight: 300 }}>
                  <Table className="project-list-table  table-borderless ">
                    <thead>
                      <tr className="table-warning">
                        <th scope="col">S.No.</th>
                        <th scope="col">Name</th>
                        <th scope="col">School ID</th>
                        <th scope="col">HealthcareFacility Id</th>
                        <th scope="col">Active</th>
                        <th scope="col">Deleted</th>
                        <th scope="col" />
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(schoolClinicsList) ? (
                        schoolClinicsList
                          ?.sort((a, b) => a?.order - b?.order)
                          ?.map((data, index) => {
                            return (
                              <tr key={index} className={data?.active ? '' : 'bg-danger text-emphasis-warning'}>
                                <td>{index + 1}</td>
                                <td>
                                  <Link
                                    to={buildURL(SMKLinks.SCHOOL_CLINIC_DETAILS, {
                                      id: data?.id,
                                    })}>
                                    {data?.name}
                                  </Link>
                                </td>
                                <td>{data?.schoolId}</td>
                                <td>{data?.healthcareFacilityId}</td>
                                <td>
                                  <Badge className={data?.active ? 'bg-success' : 'bg-danger'}>
                                    {data?.active ? 'Yes' : 'No'}
                                  </Badge>
                                </td>
                                <td>
                                  <Badge className={data?.deleted ? 'bg-success' : 'bg-danger'}>
                                    {data?.deleted ? 'Yes' : 'No'}
                                  </Badge>
                                </td>
                                <td>
                                  <UncontrolledDropdown>
                                    <DropdownToggle href="#" className="card-drop " tag="i">
                                      <i role="button" className="mdi mdi-dots-vertical font-size-18 " />
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-end">
                                      <DropdownItem onClick={() => handleUpdateSchoolClinic(data)}>
                                        <i
                                          className={`fas  ${
                                            data?.active ? 'fa-ban text-danger' : 'fa-power-off text-success'
                                          }   m-1 pe-3`}
                                        />
                                        {data?.active ? 'Disable' : 'Enable (Active)'}
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td>
                              </tr>
                            );
                          })
                      ) : (
                        <TableError />
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>
          {/* <Paginate pageInfo={schoolClinicsPagination} onChangePage={handleChangePage} /> */}
        </Container>
      </div>
    </>
  );
};

export default SchoolClinicListing;
